import { ActiveFarmPanel } from '../components/active-farm-panel/ActiveFarmPanel'
import { ChartsPanel } from '../components/charts-panel/ChartsPanel'
import { DepositCTAPanel } from '../components/deposit-cta-panel/DepositCTAPanel'
import { GeneralStatsBar } from '../components/general-stats-bar/GeneralStatsBar'
import { TokensToDepositPanel, TokensToDepositRow } from '../components/tokens-to-deposit-panel/TokensToDepositPanel'
import { MainPanelData, SpkFarmChartDetails, SpkFarmGeneralStatsResult } from '../types'
import { tokenLogos } from '@/config/chain/configs/mainnet/assets'
import { NetworkBadge } from '@/ui/atoms/network-badge/NetworkBadge'
import { PageLayout } from '@/ui/layouts/PageLayout'

export interface SpkFarmViewProps {
  chainId: number
  generalStatsResult: SpkFarmGeneralStatsResult
  mainPanelData: MainPanelData
  chartDetails: SpkFarmChartDetails
  tokensToDepositRow: TokensToDepositRow
}

export function SpkFarmView({
  chainId,
  generalStatsResult,
  mainPanelData,
  chartDetails,
  tokensToDepositRow,
}: SpkFarmViewProps) {
  return (
    <PageLayout>
      <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-row items-center gap-5">
          <div className="flex flex-row items-center gap-3">
            <img src={tokenLogos.spk} alt="SPK" className="size-10" />
            <h1 className="typography-heading-3 md:typography-heading-1">SPK Farm</h1>
          </div>
          <NetworkBadge chainId={chainId} />
        </div>
        <GeneralStatsBar generalStatsResult={generalStatsResult} />
      </div>
      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {mainPanelData.type === 'cta' ? (
            <DepositCTAPanel {...mainPanelData.props} />
          ) : (
            <ActiveFarmPanel {...mainPanelData.props} />
          )}
          <ChartsPanel chartDetails={chartDetails} />
        </div>
        <TokensToDepositPanel {...tokensToDepositRow} />
      </div>
    </PageLayout>
  )
}
